module.exports = __webpack_public_path__ + "static/media/Message-Outline.c5d75999.svg";